var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "results" } }, [
    _vm.$root.fittings.length
      ? _c(
          "div",
          [
            _vm.recommendedSize !== ""
              ? _c("div", { staticClass: "recommended-size" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$root.type) +
                      " SIZE: " +
                      _vm._s(_vm.recommendedSize) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n      Below are products recommended just for you!\n    "
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.$root.fittings, function (product) {
              return _c("result", {
                key: product.shopify_id,
                attrs: { product: product },
              })
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.fittings && !_vm.$root.fittings.length
      ? _c("p", [
          _vm._v("\n    " + _vm._s(_vm.no_fittings_message) + "\n    "),
          _c("br"),
          _vm._v(
            "\n    No products match your search. We recommend ordering your typical swimsuit size. For a personalized fit recommendation please reach out to us at hello@kortnijeane.com.\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.$root.fittings ? _c("p", [_vm._v("\n    Loading...\n  ")]) : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ff-logo" }, [
      _c("div", [_vm._v("\n        Powered by\n      ")]),
      _vm._v(" "),
      _c("img", { attrs: { src: require("../img/ff-logo.svg") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }